import { render } from "./team-member-mandatory-data.vue?vue&type=template&id=6d73a0f4&scoped=true&ts=true"
import script from "./team-member-mandatory-data.vue?vue&type=script&lang=ts"
export * from "./team-member-mandatory-data.vue?vue&type=script&lang=ts"

import "./team-member-mandatory-data.vue?vue&type=style&index=0&id=6d73a0f4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d73a0f4"]])

export default __exports__